import './ConsultModal.css';

import React from 'react';
import { Modal, Input, PhoneInput, Button, Typography, Checkbox, Link } from '@vtblife/uikit';

import classname from '@search/classname/src';

const cn = classname.bind(null, 'ConsultModal');

type DomainProps = {
    isFormSending: boolean;
    isFormSended: boolean;
    phone: string;
    isPhoneTouched: boolean;
    name: string;
    isNameTouched?: boolean;
    phoneInputValid?: boolean;
    nameInputValid?: boolean;
    setName?: (newName: string) => void;
    setPhone?: (newPhone: string) => void;
    setPhoneTouched: () => void;
    setNameTouched?: () => void;
};

export type ConsultModalProps = {
    isMobile?: boolean;
    onClose?(): void;
    send(e?: React.FormEvent<HTMLFormElement> | React.KeyboardEvent<HTMLInputElement>): void;
    subtitle?: React.ReactNode | string;
    title: string;
    sendedContent?: React.ReactNode;
    sizeFields: 's' | 'm' | 'l';
    withName?: boolean;
    sendActionText?: string;
    domain: DomainProps;
    renderWorkingHours?: React.ReactNode;
    nameLabel?: string;
    phoneLabel?: string;
};

export function ConsultModal({
    isMobile,
    onClose,
    renderWorkingHours,
    title,
    subtitle,
    sendedContent,
    sendActionText = 'Отправить',
    send,
    sizeFields,
    domain,
    withName,
    nameLabel,
    phoneLabel
}: ConsultModalProps) {
    const [ isAgree, setIsAgree ] = React.useState(true);

    const sendOnEnter = React.useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key !== 'Enter' || ! isAgree) return;
        send(e);
    }, [ send ]);

    return (<Modal
        opened
        size='s'
        onClose={onClose}
        mobile={isMobile}
        swipeToClose={! isMobile}
    >
        {isMobile ? (
            <Modal.Header>{title}</Modal.Header>
        ) : (
            <Modal.Title>{title}</Modal.Title>
        )}
        {subtitle && (
            <Typography
                color={isMobile ? undefined : 'black-450'}
                className={cn('subtitle', { isMobile })}
            >
                {subtitle}
            </Typography>
        )}
        {domain.isFormSended ? sendedContent : (
            <form className={cn('group', { isMobile })} onSubmit={send}>
                {withName && (
                    <Input
                        dataTest='consult-set-name'
                        label={nameLabel ?? 'Имя'}
                        placeholder='Имя'
                        size={sizeFields}
                        onBlur={domain.setNameTouched}
                        onKeyPress={sendOnEnter}
                        error={domain.nameInputValid === false}
                        onChange={domain.setName}
                        value={domain.name}
                        disabled={domain.isFormSending}
                    />
                )}
                <PhoneInput
                    dataTest='consult-set-phone'
                    label={phoneLabel ?? 'Телефон'}
                    size={sizeFields}
                    inputMode='numeric'
                    onBlur={domain.setPhoneTouched}
                    onKeyPress={sendOnEnter}
                    hint={domain.isPhoneTouched && ! domain.phoneInputValid ? 'Введите номер телефона' : ''}
                    onChange={domain.setPhone}
                    value={domain.phone || undefined}
                    disabled={domain.isFormSending}
                    error={domain.isPhoneTouched && ! domain.phoneInputValid}
                />
                {renderWorkingHours}
                <Checkbox
                    block={true}
                    value={isAgree}
                    onChange={(value) => setIsAgree(value)}
                >
                    <Typography className={cn('checkbox-container')}>
                        Принимаю&nbsp;условия&nbsp;
                        <Link href='https://cdn.m2.ru/assets/pdfs/polzovatelskoe-soglashenie.pdf' target='blank' text={true}>
                            <Typography className={cn('link-text')}>
                                Пользовательского соглашения
                            </Typography>
                        </Link>
                            &nbsp;и даю&nbsp;
                        <Link href='/doc/clients/soglasiya/personal-data-agreement-selection-of-a-realtor-from-m2/' target='blank'>
                            <Typography className={cn('link-text')}>
                                Согласие на обработку персональных данных
                            </Typography>
                        </Link>
                            &nbsp;в соответствии с&nbsp;
                        <Link href='/doc/clients/politiki/privacy-policy/' target='blank'>
                            <Typography className={cn('link-text')}>
                                Политикой конфиденциальности
                            </Typography>
                        </Link>
                    </Typography>
                </Checkbox>
                <Button
                    fullWidth
                    type='submit'
                    size={isMobile ? 'm' : 'l'}
                    disabled={domain.isFormSending || ! isAgree}
                    dataTest='consult-send'
                >
                    {sendActionText}
                </Button>
            </form>
        )}
    </Modal>);
}
